import { createAction, props } from '@ngrx/store';
import { EntityKey } from '@feature/pma-entity/pma-entity-types';
import {
  BudgetOptionValue,
  BudgetVsActualData,
  SortOrderValue,
  Schedule,
  BudgetVsActualWidgetConfig
} from '../models/budget-vs-actual-data.model';
import {ITable} from "@feature/common";

const source = '[Budget Vs Actual Widget]';
const name = (actionName: string) => `${source} ${actionName}`;

export const BudgetDataLoad = createAction(
  name('Load Budget Data'),
  props<{
    widgetId: number;
    entityKey: EntityKey;
    propertyTaskUri: number;
    budgetPeriodUris: number[];
  }>()
);

export const BudgetDataLoadComplete = createAction(
  name('Load Budget Data Complete'),
  props<{
    widgetId: number;
    data: BudgetVsActualData[];
    currencyCode: string;
    propertyRef: number;
    propertyName: string;
    year: string;
    unitRef: number;
  }>()
);

export const BudgetDataLoadError = createAction(
  name('Load Budget Data Error'),
  props<{
    widgetId: number;
    error: any;
  }>()
);

export const ScheduleChange = createAction(
name('Schedule Data Changed'),
props<{
  widgetId: number;
  scheduleRefs: number[];
}>()
);

export const SelectedBudgetChange = createAction(
  name('Selected Budget Changed'),
  props<{
    widgetId: number;
    selectedBudget: BudgetOptionValue;
  }>()
);


export const SortOrderChange = createAction(
  name('Sort Order Changed'),
  props<{
    widgetId: number;
    selectedSortOrder: SortOrderValue;
  }>()
);


export const ColumnsChange = createAction(
  name('Column Data Changed'),
  props<{
    widgetId: number;
    columns: string[];
  }>()
);

export const PeriodChanged = createAction(
  name('Period Changed'),
  props<{
    widgetId: number;
    period: (string | number)[];
  }>()
);

export const SetColumnsComplete = createAction(
  name('Set Columns Complete'),
  props<{
    widgetId: number;
  }>()
);

export const SetColumnsError = createAction(
  name('Set Columns Error'),
  props<{
    widgetId: number;
    error: any;
  }>()
);

export const Clear = createAction(
  name('Clear Data'),
  props<{
    widgetId: number;
  }>()
)

export const SelectedColumnsLoad = createAction(
  name('Load Selected Columns'),
  props<{
    widgetId: number;
  }>()
);

export const SelectedColumnsLoadComplete = createAction(
  name('Load Selected Columns Complete'),
  props<{
    widgetId: number;
    columns: string[];
  }>()
);

export const SelectedColumnsLoadError = createAction(
  name('Load Selected Columns Error'),
  props<{
    widgetId: number;
    error: any;
  }>()
);

export const apiLoad = createAction(
  name('API Load'),
  props < {
    widgetId: number;
    dashboardIdentifier: string;
    entityKey: EntityKey;
    external: boolean;
    includeCommitments: boolean;
    includeCommitmentsSystemDefault: boolean;
  }>()
);

export const apiLoadComplete = createAction(
  name('API Load Complete'),
  props<{ widgetId: number; data: ITable }>()
);

export const getBvAWidgetConfigComplete = createAction(
  `BvA Widget Config Complete`,
  props<{widgetId: number; config: BudgetVsActualWidgetConfig}>());
